import script from "./AdvisorsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvisorsList.vue?vue&type=script&setup=true&lang=ts"

import "./AdvisorsList.vue?vue&type=style&index=0&id=141bb164&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141bb164"]])

export default __exports__